import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealStageHistory";

export function selectByDealId(dealId){
  return axios({
    url: `/ws/${moduleName}/selectByDealId/${dealId}`,
    method: 'get',
  })
}

export default {
  selectByDealId,
}